import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SliderCard from './SliderCard';
import Classes from './BrandSlider.module.css';
import { useNavigate } from 'react-router-dom';

export default function BrandSlider({ Products, title, page }) {
    const navigateTo = useNavigate();

    return (
        <div className={Classes.slider} >
            <div className={Classes.header} >
                {title && <h2 className={Classes.title} >{title}</h2>}
                <button onClick={() => { navigateTo(page) }} className={Classes.primaryBtn} > <h5>View All</h5> </button>
            </div>
            <Swiper
                slidesPerView={4}
                pagination={false}
                className={Classes.mySwiper}
                breakpoints={{
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    481: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1000: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    },
                }}
            >
                {Products && Products?.map((Product, index) => {
                    return (
                        <>
                            <SwiperSlide key={index} > <SliderCard Product={Product} /> </SwiperSlide>
                        </>
                    )
                })}
            </Swiper>
        </div>
    )
}
